'use strict';

var module = angular.module('doclr.components.adminagendacomponents', [
    'ui.router',
    '$strap.directives',
    'doclr.components.agenda',
    'doclr.resources.api',
    'doclr.praktijk',
    'doclr.components.notification',
    'doclr.components.vrijgavestrategieselector',
    'doclr.printer',
    'ui.bootstrap.typeahead'
]);


module.constant('agendaNestedStatesConfigurator', function ($stateProvider, parentStateName) {
    $stateProvider
        .state(parentStateName + '.aantekeningmaken', {
            url: '/nieuwe-aantekening?dagClicked&uur&agenda',
            resolve: {
                praktijk: function (Praktijk, praktijkContext) {
                    return Praktijk.getInfo(praktijkContext.id);
                },
                selectedAgenda: function (agendas, $stateParams) {
                    return agendas.findAgendaVoorId(decodeURIComponent($stateParams.agenda));
                },
                beschikbaarheidTypes: function (BeschikbaarheidTypes, praktijkContext) {
                    return BeschikbaarheidTypes.getTypes(praktijkContext.id);
                }
            },
            views: {
                '@': {
                    templateUrl: '/partials/adminagenda/aantekeningmaken.html',
                    controller: function ($scope,
                                          $state,
                                          $stateParams,
                                          beschikbaarheidTypes,
                                          agendaBoundaries,
                                          agendas,
                                          slicesService,
                                          praktijkContext,
                                          selectedAgenda,
                                          notificationService,
                                          borderColor,
                                          praktijk,
                                          localStorageService) {

                        const filteredTypes = beschikbaarheidTypes
                            .filter(type => type.event_type === "beschikbaarheid")
                            .filter(type => selectedAgenda.disciplineName === type.disciplineName)
                            .filter(type => type.isActive);
                        $scope.availableTypes = localStorageService.sortTypesByLocalStorage(filteredTypes, 'calendar', doclrStaticUtils.getUUIDFromObjectWithId(selectedAgenda));

                        $scope.praktijk = praktijk;
                        $scope.form = {};
                        $scope.form.beschikbaarheid = true;
                        $scope.form.selectedType = $scope.availableTypes[0];
                        $scope.form.afspraakDuur = $scope.form.selectedType.duur;
                        $scope.form.aantalAfspraken = 1;
                        $scope.form.availabilityReleaseStrategy = AvailabilityReleaseStrategy.createNew();
                        $scope.form.selectedAgenda = selectedAgenda;

                        $scope.form.interval = {};
                        $scope.form.interval.dagVan = $stateParams.dagClicked;
                        var startUur = moment($stateParams.uur, 'HH:mm');
                        $scope.form.interval.uurVan = startUur.format('HH:mm');
                        $scope.form.interval.dagTot = $stateParams.dagClicked;
                        $scope.form.interval.uurTot = startUur.add($scope.form.selectedType.duur, 'minutes').format('HH:mm');
                        $scope.form.interval.heleDag = false;

                        $scope.borderColor = function (type) {
                            return borderColor(type.kleur);
                        };

                        $scope.$watch('form.selectedType', function (newValue, oldValue) {
                            if (newValue === oldValue) {
                                return;
                            }

                            if (!newValue) {
                                return
                            }
                            $scope.form.afspraakDuur = newValue.duur;
                            $scope.form.availabilityReleaseStrategy = AvailabilityReleaseStrategy.createNew();
                        });

                        $scope.$watchGroup(['form.afspraakDuur', 'form.aantalAfspraken', 'form.interval.uurVan', 'form.beschikbaarheid'], function (newValue, oldValue) {
                            if (newValue === oldValue) {
                                return;
                            }

                            function calculateTotUur(offsetMinuten) {
                                var vanUur = moment($scope.form.interval.uurVan, 'HH:mm');
                                var totNieuw = vanUur.add(offsetMinuten, 'minutes');
                                return totNieuw.format('HH:mm');
                            }

                            function getOffsetMinuten() {
                                return $scope.form.afspraakDuur * $scope.form.aantalAfspraken;
                            }

                            $scope.form.interval.uurTot = calculateTotUur(getOffsetMinuten());

                        });

                        $scope.terug = function () {
                            slicesService.reload();
                            $state.go('^');
                        };

                        $scope.maakBeschikbaarheid = function () {
                            let form = $scope.form;

                            localStorageService.addSortTypeByLocalStorage(form.selectedType,
                                'calendar',
                                doclrStaticUtils.getUUIDFromObjectWithId(form.selectedAgenda));

                            form.selectedAgenda
                                .maakBeschikbaarheid(
                                    form.interval.dagVan,
                                    form.interval.uurVan,
                                    form.interval.uurTot,
                                    form.afspraakDuur,
                                    form.aantalAfspraken,
                                    form.availabilityReleaseStrategy,
                                    form.selectedType.id,
                                    form.titel,
                                    form.reden)
                                .then(function () {
                                    return $state.go('^');
                                })
                                .then(function () {
                                    return slicesService.slicesLoader.navigator.wijzigDagEnAgenda(form.interval.dagVan, form.selectedAgenda.id);
                                });
                        };
                    }
                }
            }
        })
        .state(parentStateName + '.afwezigheid', {
            url: '/afwezigheid?absenceId&isPartyAbsence&calendarId&dagClicked&uur&agenda',
            resolve: {
                selectedAgendaOrResource: function (agendas, resources, $stateParams) {
                    let agenda = agendas.findAgendaVoorId(decodeURIComponent($stateParams.agenda));
                    let resource = resources.findResourceVoorId(decodeURIComponent($stateParams.agenda));
                    return agenda || resource;
                },
                absence: function ($stateParams, Absences, praktijkContext, selectedAgendaOrResource) {
                    if ($stateParams.absenceId) {
                        return Absences.getAbsence($stateParams.calendarId, $stateParams.absenceId, $stateParams.isPartyAbsence === "true")
                            .then((absence) => {

                                return {
                                    id: $stateParams.absenceId,
                                    titel: absence.subject,
                                    reden: absence.description,
                                    interval: {
                                        dagVan: absence.fromDay,
                                        dagTot: absence.untilDay,
                                        uurVan: absence.fromTime,
                                        uurTot: absence.untilTime,
                                        heleDag: absence.isWholeDay,
                                    },
                                    calendarId: absence.calendarId,
                                    isPartyAbsence: absence.isPartyAbsence,
                                    multiCalendarSelection: {
                                        forAllCalendars: absence.forAllCalendars,
                                        calendarIds: absence.calendarIds,
                                        defaultCalendarId: undefined,
                                    }
                                }
                            });
                    } else {
                        let startUur = moment($stateParams.uur, 'HH:mm');
                        return {
                            titel: undefined,
                            reden: undefined,

                            interval: {
                                dagVan: $stateParams.dagClicked,
                                uurVan: startUur.format('HH:mm'),
                                dagTot: $stateParams.dagClicked,
                                uurTot: startUur.add(60, 'minutes').format('HH:mm'),
                                heleDag: false,
                            },
                            multiCalendarSelection: {
                                forAllCalendars: false,
                                calendarIds: [selectedAgendaOrResource.uuid],
                                defaultCalendarId: selectedAgendaOrResource.uuid,
                            }
                        }
                    }
                }
            },
            views: {
                '@': {
                    templateUrl: '/partials/adminagenda/afwezigheidmaken.html',
                    controller: function ($scope,
                                          $state,
                                          $stateParams,
                                          slicesService,
                                          absence,
                                          selectedAgendaOrResource,
                                          Absences) {
                        $scope.absence = absence;
                        $scope.selectedAgendaOrResource = selectedAgendaOrResource;
                        $scope.isNew = !absence.id;


                        $scope.terug = function () {
                            slicesService.reload();
                            $state.go('^');
                        };

                        $scope.bewaren = function () {


                            if ($scope.isNew) {
                                let multiCalendarSelection = undefined;
                                if (!selectedAgendaOrResource.isResource && (absence.multiCalendarSelection.forAllCalendars || absence.multiCalendarSelection.calendarIds.length > 1)) {
                                    multiCalendarSelection = absence.multiCalendarSelection;
                                }

                                selectedAgendaOrResource
                                    .maakAfwezigheid(multiCalendarSelection, absence.interval, absence.titel, absence.reden)
                                    .then(function () {
                                        return $state.go('^');
                                    })
                                    .then(function () {
                                        return slicesService.slicesLoader.navigator.wijzigDagEnAgenda(absence.interval.dagVan, selectedAgendaOrResource.id);
                                    });

                            } else {
                                Absences.updateAbsence(absence.id, absence.calendarId, {
                                    isWholeDay: absence.interval.heleDag,
                                    fromTime: absence.interval.uurVan,
                                    untilTime: absence.interval.uurTot,
                                    subject: absence.titel,
                                    description: absence.reden
                                }, absence.isPartyAbsence)
                                    .then(function () {
                                        return $state.go('^');
                                    })
                                    .then(function () {
                                        return slicesService.slicesLoader.reload()
                                    });
                            }
                        };
                    }
                }
            }
        })

        .state(parentStateName + '.afspraakdetail', {
            url: '/afspraak-details?afspraakId&dagClicked&uur&duur&agenda&typeId',
            resolve: {
                afspraak: function ($stateParams, Afspraken, praktijkContext) {
                    if ($stateParams.afspraakId) {
                        return Afspraken.getAfspraak(decodeURIComponent($stateParams.afspraakId));
                    } else {
                        var startUur = moment($stateParams.uur, 'HH:mm');
                        var duur = $stateParams.duur ? parseInt($stateParams.duur, 10) : praktijkContext.minutenTussenLijnen;

                        return {
                            dag: $stateParams.dagClicked,
                            agendaId: decodeURIComponent($stateParams.agenda),
                            van: startUur.format('HH:mm'),
                            tot: startUur.add(duur, 'minutes').format('HH:mm'),
                            typeId: $stateParams.typeId,
                            language: "nl"
                        };
                    }
                },
                selectedAgenda: function (agendas, $stateParams) {
                    return agendas.findAgendaVoorId(decodeURIComponent($stateParams.agenda));
                },
                praktijk: function (Praktijk, praktijkContext) {
                    return Praktijk.getInfo(praktijkContext.id);
                },
                beschikbaarheidTypes: function (BeschikbaarheidTypes, praktijkContext) {
                    return BeschikbaarheidTypes.getTypes(praktijkContext.id);
                }
            },
            views: {
                '@': {
                    templateUrl: '/partials/adminagenda/afspraakdetail.html',
                    controller: function ($scope,
                                          $state,
                                          $stateParams,
                                          agendas,
                                          afspraak,
                                          slicesService,
                                          praktijk,
                                          beschikbaarheidTypes,
                                          notificationService,
                                          borderColor,
                                          Praktijk,
                                          RecurrenteAfspraken,
                                          AppoinmentCreateService,
                                          selectedAgenda,
                                          localStorageService,
                                          appContext,
                                          Resources,
                                          DoclrModalService,
                                          Afspraken,
                                          $timeout
                    ) {

                        $scope.borderColor = function (type) {
                            return borderColor(type.kleur);
                        };
                        $scope.selectedAgenda = selectedAgenda;

                        $scope.nieuw = !afspraak.id;

                        $scope.appContext = appContext;

                        $scope.resources = appContext.resources.map(resource => {
                            return {
                                isSelected: false,
                                ...resource
                            }
                        });

                        $scope.resourcesAvailabilities = {
                            day: undefined,
                            availabilities: undefined
                        }

                        function afterFetchAvailability(day, resourcesAvailabilities) {
                            if (day !== afspraak.dag) {
                                return;
                            }
                            $scope.resourcesAvailabilities.day = day;
                            $scope.resourcesAvailabilities.availabilities = resourcesAvailabilities;

                            checkResources();

                        }

                        function checkResources() {

                            if (!afspraak.dag) {
                                return;
                            }

                            if (afspraak.dag !== $scope.resourcesAvailabilities.day) {
                                getResourceAvailabilities(afspraak.dag);
                                return;
                            }

                            if (!afspraak.van || !afspraak.tot) {
                                return;
                            }

                            let start = doclrStaticUtils.toMinutes(afspraak.van);
                            let end = doclrStaticUtils.toMinutes(afspraak.tot);

                            $scope.resources.forEach(resource => {
                                var filter = $scope.resourcesAvailabilities.availabilities.filter(x => x.resourceId === resource.id);
                                if (filter.length > 0) {
                                    if (checkAvailability(filter[0], afspraak.dag, start, end)) {
                                        resource.availableClass = "status-ok";
                                    } else {
                                        resource.availableClass = "status-nok";
                                    }
                                } else {
                                    resource.availableClass = "status-nok";
                                }
                            });
                        }


                        function overlaps(firstStart, firstEnd, lastStart, lastEnd) {
                            if (firstStart < lastStart) {
                                return overlaps(lastStart, lastEnd, firstStart, firstEnd);
                            }
                            return !(firstEnd <= lastStart || lastEnd <= firstStart);

                        }

                        function checkAvailability(resourceAvailabilities, day, start, end) {
                            if (!resourceAvailabilities || !resourceAvailabilities.unAvailablePeriods) {
                                return false; //No info, return false
                            }

                            if (!resourceAvailabilities.unAvailablePeriods[day]) {
                                return true; // No unavailable periods, always ok;
                            }

                            //if any overlap return false
                            return !resourceAvailabilities.unAvailablePeriods[day]
                                .some(unavailablePeriod => overlaps(start, end, unavailablePeriod.start, unavailablePeriod.end))
                        }


                        function getResourceAvailabilities(dag) {
                            Resources.getDayAvailability(dag).then(resourcesAvailabilities => afterFetchAvailability(dag, resourcesAvailabilities));
                        }

                        checkResources();

                        $scope.$watchGroup(['afspraak.van', 'afspraak.tot', 'afspraak.dag'], function (newValue, oldValue) {
                            if (newValue === oldValue) {
                                return;
                            }

                            if (!afspraak.van || !afspraak.tot || afspraak.van.length !== 5 || afspraak.tot.length !== 5 || !$scope.showingResources) {
                                return;
                            }
                            checkResources();
                        });


                        $scope.showResources = function () {
                            $scope.showingResources = true;
                            checkResources();
                        }

                        // ---- DOCLEAS-042: colleague participants (behave like the resource picker) ----
                        const ownerCalendarUuid = selectedAgenda ? doclrStaticUtils.getUUIDFromObjectWithId(selectedAgenda) : null;

                        $scope.showingColleagues = false;

                        $scope.colleagueCalendars = agendas
                            .filter(agenda => !agenda.isResource)
                            .filter(agenda => !selectedAgenda || agenda.disciplineName === selectedAgenda.disciplineName)
                            .filter(agenda => doclrStaticUtils.getUUIDFromObjectWithId(agenda) !== ownerCalendarUuid)
                            .map(agenda => ({
                                calendarId: doclrStaticUtils.getUUIDFromObjectWithId(agenda),
                                name: agenda.naam,
                                isSelected: false,
                                availableClass: ''
                            }));

                        $scope.toggleColleaguePicker = function () {
                            $scope.showingColleagues = !$scope.showingColleagues;
                            if ($scope.showingColleagues) {
                                checkColleagueAvailability();
                            }
                        };

                        function checkColleagueAvailability() {
                            const anySelected = $scope.colleagueCalendars.some(colleague => colleague.isSelected);
                            if ((!$scope.showingColleagues && !anySelected)
                                || $scope.colleagueCalendars.length === 0
                                || !afspraak.dag
                                || !afspraak.van || afspraak.van.length !== 5
                                || !afspraak.tot || afspraak.tot.length !== 5) {
                                return;
                            }
                            const appointmentUuid = afspraak.id ? doclrStaticUtils.getUUIDFromUrl(afspraak.id) : undefined;
                            const calendarIds = $scope.colleagueCalendars.map(colleague => colleague.calendarId);
                            Resources.checkResourceConflict(afspraak.dag, afspraak.van, afspraak.tot, calendarIds, appointmentUuid)
                                .then(result => {
                                    const conflicting = (result && result.conflictingResources) || [];
                                    $scope.colleagueCalendars.forEach(colleague => {
                                        colleague.availableClass = conflicting.includes(colleague.calendarId) ? 'status-nok' : 'status-ok';
                                    });
                                })
                                .catch(angular.noop);
                        }

                        // Re-check when the slot changes. typeId is watched too: picking another
                        // product (or a different duration) recomputes afspraak.tot in a later
                        // watcher, so defer the check with $timeout until tot has settled.
                        $scope.$watchGroup(['afspraak.van', 'afspraak.tot', 'afspraak.dag', 'afspraak.typeId'], function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                $timeout(checkColleagueAvailability);
                            }
                        });

                        if (!$scope.nieuw && afspraak.id) {
                            Afspraken.getParticipants(doclrStaticUtils.getUUIDFromUrl(afspraak.id))
                                .then(list => {
                                    const colleagueRows = (list || []).filter(participant => participant.role === 'REQUIRED' || participant.role === 'OPTIONAL');
                                    colleagueRows.forEach(participant => {
                                        const match = $scope.colleagueCalendars.filter(colleague => colleague.calendarId === participant.calendarId)[0];
                                        if (match) {
                                            match.isSelected = true;
                                        }
                                    });
                                    if (colleagueRows.length > 0) {
                                        checkColleagueAvailability();
                                    }
                                })
                                .catch(angular.noop);
                        }

                        function participantsPayload() {
                            return $scope.colleagueCalendars
                                .filter(colleague => colleague.isSelected)
                                .map(colleague => ({calendarId: colleague.calendarId, role: 'REQUIRED'}));
                        }

                        $scope.hasAvailabilityPreselected = !!afspraak.typeId;
                        $scope.form = {};

                        if ($scope.nieuw) {
                            afspraak.typeId = afspraak.typeId || _.findWhere(beschikbaarheidTypes, {'default_afspraak': true}).id;
                            $scope.form.selectedType = _.findWhere(beschikbaarheidTypes, {'id': afspraak.typeId});

                            //TODO: Filter on relation
                            const filteredTypes = beschikbaarheidTypes
                                .filter(type => type.event_type === "afspraakMogelijkheid")
                                .filter(type => selectedAgenda.disciplineName === type.disciplineName)
                                .filter(type => type.isActive);

                            $scope.availableProducts = localStorageService.sortTypesByLocalStorage(filteredTypes, 'appointment_create', doclrStaticUtils.getUUIDFromObjectWithId(selectedAgenda));

                            if ($scope.availableProducts.length > 0) {
                                $scope.form.selectedProduct = $scope.availableProducts[0];
                                var vanUur = moment(afspraak.van, 'HH:mm');
                                var totNieuw = vanUur.add($scope.form.selectedProduct.duur, 'minutes');
                                afspraak.tot = totNieuw.format('HH:mm');
                            }

                        } else {
                            $scope.form.selectedType = _.findWhere(beschikbaarheidTypes, {'id': afspraak.typeId});
                        }
                        checkIfSelectedProductNeedsResources();

                        $scope.praktijk = praktijk;
                        $scope.agendas = agendas;
                        $scope.types = _.filter(beschikbaarheidTypes, function (type) {
                            return type.met_afspraakmogelijkheden;
                        });
                        $scope.afspraak = afspraak;


                        $scope.wisselType = function (form, type) {
                            form.selectedType = type;
                            loadCustomForm([type.id]);
                            //  $scope.customForm = customForms[type.id];
                            //  if ($scope.customForm && $scope.nieuw) {
                            //      if (!afspraak.customForm) {
                            //          afspraak.customForm = {};
                            //      }
                            //      customFormFactory.update(afspraak.customForm, $scope.customForm.elements);
                            //  }
                        }

                        $scope.availableTypes = $scope.types.filter(type => type.isActive || type.id === $scope.form.selectedType.id);

                        $scope.$watch('form.selectedProduct', function (newValue) {
                            if (newValue && newValue.id) {
                                loadCustomForm([newValue.id]);
                                afspraak.typeId = newValue.id;
                                checkIfSelectedProductNeedsResources()
                            }
                        });

                        $scope.$watch('form.selectedType', function (newValue) {
                            afspraak.typeId = newValue.id;
                        });

                        $scope.$watch('afspraak.typeId', function (newValue, oldValue) {
                            if (newValue === oldValue) {
                                return;
                            }
                            var beschikbaarheidType = _.findWhere(beschikbaarheidTypes, {id: newValue});
                            var vanUur = moment($scope.afspraak.van, 'HH:mm');
                            var totNieuw = vanUur.add(beschikbaarheidType.duur, 'minutes');
                            $scope.afspraak.tot = totNieuw.format('HH:mm');
                        });

                        //CUSTOM FIELDS

                        $scope.customForm = {fields: []};
                        $scope.getListOptions = customFormFactory.getListOptions;
                        $scope.fieldConfig = {
                            isFirstNameVisible: true,
                            isFirstNameRequiredForUser: false,
                            isNameVisible: true,
                            isNameRequiredForUser: false,
                            isPhoneVisible: true,
                            isPhoneRequiredForUser: false,
                            isSsinVisible: true,
                            isSsinRequiredForUser: false,
                            isBirthDateVisible: true,
                            isBirthDateRequiredForUser: false,
                            isMailVisible: true,
                            isMailRequiredForUser: false
                        };

                        function loadCustomForm(appointmentTypeIds) {
                            const appointmentTypes = appointmentTypeIds.map(id => doclrUtilsList.getFirst(appContext.appointmentTypes.filter(x => x.id === id)))
                                .filter(x => !!x);

                            customFormFactory.updateCustomForm(appointmentTypes, $scope.customForm);
                            customFormFactory.updateFieldConfig(appointmentTypes, $scope.fieldConfig);
                        }

                        loadCustomForm([$scope.form.selectedProduct.id]);

                        $scope.bewaren = function () {
                            saveAppointment({});
                        };

                        $scope.zoekPatientOpNaam = function (naam) {
                            return Praktijk.zoekPatientOpNaam(naam, praktijk.id);
                        };

                        $scope.zoekPatientOpGeboortedatum = function (geboortedatum) {
                            return Praktijk.zoekPatientOpGeboortedatum(geboortedatum, praktijk.id);
                        };

                        $scope.selecteerPatient = function (patient) {
                            $scope.afspraak.naam = patient.naam;
                            $scope.afspraak.voornaam = patient.voornaam;
                            $scope.afspraak.geboortedatum = patient.geboortedatum;

                            let newInsz = patient.rijksregisternummer

                            function addCharAt(str, chara, at) {
                                if (str.length >= at) {
                                    return [str.slice(0, at), chara, str.slice(at)].join('');
                                }
                                return str;
                            }

                            if (newInsz) {
                                //Enkel nummers
                                newInsz = newInsz.replace(/[^\d]/g, '');

                                newInsz = addCharAt(newInsz, '.', 2);
                                newInsz = addCharAt(newInsz, '.', 5);
                                newInsz = addCharAt(newInsz, '-', 8);
                                newInsz = addCharAt(newInsz, '.', 12);
                            }

                            $scope.afspraak.rijksregisternummer = newInsz;
                            $scope.afspraak.email = patient.email;
                            $scope.afspraak.telefoon = patient.telefoon;
                            $scope.afspraak.language = patient.language;
                        };

                        $scope.annuleren = function () {
                            slicesService.reload();
                            $state.go('^');
                        };

                        function saveAppointment(acknowledged) {
                            acknowledged = acknowledged || {};
                            const acknowledge = key => Object.assign({}, acknowledged, {[key]: true});

                            if ($scope.nieuw && !acknowledged.past) {
                                const afspraakDag = moment(afspraak.dag, 'YYYY-MM-DD');
                                if (afspraakDag.isBefore(moment(), 'day')) {
                                    DoclrModalService.openConfirmModal(
                                        "Afspraak in het verleden.",
                                        "Deze afspraak ligt in het verleden. Wil je toch doorgaan?"
                                    )
                                        .then(() => saveAppointment(acknowledge('past')))
                                        .catch(angular.noop);
                                    return;
                                }
                            }

                            checkResources();

                            const noResourceSelectedWhenNeeded = $scope.selectedProductNeedsResources && getSelectedNamedResources().length === 0;
                            if (noResourceSelectedWhenNeeded && !acknowledged.noResourceSelected) {
                                DoclrModalService.openConfirmModal(
                                    "Geen benodigdheid geselecteerd.",
                                    "Voor deze afspraak heb je geen benodigdheid geselecteerd. Voor dit type van afspraken is dat wel verwacht. Wil je toch doorgaan?"
                                )
                                    .then(() => saveAppointment(acknowledge('noResourceSelected')))
                                    .catch(angular.noop);
                                return;
                            }

                            const hasOccupiedResourceSelected = $scope.resources && $scope.resources
                                .some(resource => resource.isSelected && resource.availableClass === "status-nok");
                            if (hasOccupiedResourceSelected && !acknowledged.occupiedResource) {
                                DoclrModalService.openConfirmModal(
                                    "Benodigdheid al bezet.",
                                    "Een of meer geselecteerde benodigdheden zijn bezet voor dit tijdstip. Wil je toch verdergaan?"
                                )
                                    .then(() => saveAppointment(acknowledge('occupiedResource')))
                                    .catch(angular.noop);
                                return;
                            }

                            const hasUnavailableColleagueSelected = $scope.colleagueCalendars
                                .some(colleague => colleague.isSelected && colleague.availableClass === "status-nok");
                            if (hasUnavailableColleagueSelected && !acknowledged.unavailableColleague) {
                                DoclrModalService.openConfirmModal(
                                    "Agenda niet beschikbaar.",
                                    "Een of meer geselecteerde agenda's zijn niet beschikbaar voor dit tijdstip. Wil je toch verdergaan?"
                                )
                                    .then(() => saveAppointment(acknowledge('unavailableColleague')))
                                    .catch(angular.noop);
                                return;
                            }

                            const selectedResourceIds = getSelectedNamedResources().map(r => r.id);
                            if (selectedResourceIds.length && !acknowledged.resourceConflict) {
                                Resources.checkResourceConflict(afspraak.dag, afspraak.van, afspraak.tot, selectedResourceIds)
                                    .then(result => {
                                        if (result && result.conflictingResources && result.conflictingResources.length > 0) {
                                            result.conflictingResources.forEach(id => {
                                                const resource = $scope.resources.find(r => r.id === id);
                                                if (resource) resource.availableClass = "status-nok";
                                            });
                                            DoclrModalService.openConfirmModal(
                                                "Benodigdheid al bezet.",
                                                "Een of meer geselecteerde benodigdheden zijn bezet voor dit tijdstip. Wil je toch verdergaan?"
                                            )
                                                .then(() => saveAppointment(acknowledge('resourceConflict')))
                                                .catch(angular.noop);
                                            return;
                                        }
                                        saveAppointment(acknowledge('resourceConflict'));
                                    })
                                    .catch(angular.noop);
                                return;
                            }

                            let calendar = selectedAgenda;

                            let appointment = {}

                            Object.assign(appointment, afspraak);

                            if ($scope.nieuw) {

                                let namedResources = getSelectedNamedResources();

                                let reason = doclrVertaal.translateType($scope.form.selectedProduct);
                                const extraReasonValues = customFormFactory.getExtraReasonValues($scope.form.selectedProduct.id, $scope.customForm);
                                if (extraReasonValues.length > 0) {
                                    reason = reason + " ; " + extraReasonValues.join(" -- ");
                                }

                                appointment = {
                                    naam: afspraak.naam,
                                    voornaam: afspraak.voornaam,
                                    geboortedatum: afspraak.geboortedatum,
                                    rijksregisternummer: afspraak.rijksregisternummer,
                                    email: afspraak.email,
                                    telefoon: afspraak.telefoon,
                                    reden: reason,
                                    voorwaardenAanvaard: true,
                                    typeId: $scope.form.selectedProduct.id,
                                    van: afspraak.van,
                                    tot: afspraak.tot,
                                    dag: afspraak.dag,
                                    resources: namedResources,
                                    participants: participantsPayload(),
                                    language: afspraak.language,
                                    customForm: {
                                        activities: [
                                            {
                                                id: $scope.form.selectedProduct.id,
                                                numberOfPersons: 1,
                                                customFormFields: customFormFactory.getValues($scope.form.selectedProduct.id, $scope.customForm)
                                            }
                                        ]
                                    },
                                    appointmentLength: 10
                                }
                                localStorageService.addSortTypeByLocalStorage($scope.form.selectedProduct,
                                    'appointment_create',
                                    doclrStaticUtils.getUUIDFromObjectWithId($scope.selectedAgenda));
                                AppoinmentCreateService.createAppointment(appointment, calendar);
                            } else {
                                afspraak.saveWijzigingen()
                                    .then((response) => Afspraken.updateParticipants(doclrStaticUtils.getUUIDFromUrl(afspraak.id), participantsPayload()).then(() => response))
                                    .then((response) => AppoinmentCreateService.afterSave(response, appointment, calendar, false))
                                    .catch(() => notificationService.showDanger("Er is een fout opgetreden. Probeer opnieuw."));
                            }
                        }

                        function getSelectedNamedResources() {
                            if ($scope.resources) {
                                return $scope.resources
                                    .filter(x => x.isSelected)
                                    .map(x => {
                                        return {
                                            name: x.name,
                                            id: x.id
                                        }
                                    })
                            }

                            return [];
                        }

                        function splitResourcesByProduct() {
                            if (!$scope.resources || $scope.resources.length === 0) {
                                $scope.correlatedResources = [];
                                $scope.otherResources = [];
                                return;
                            }

                            const product = $scope.form.selectedProduct;
                            if (!product || !product.resourceTypes || !product.resourceTypes.length) {
                                $scope.correlatedResources = [];
                                $scope.otherResources = $scope.resources.slice().sort((a, b) => a.name.localeCompare(b.name));
                                return;
                            }

                            const isCorrelated = resource => resource.resourceTypes && resource.resourceTypes
                                .some(type => product.resourceTypes.includes(type));

                            const sortByName = (a, b) => a.name.localeCompare(b.name);
                            $scope.correlatedResources = $scope.resources.filter(isCorrelated)
                                .sort(sortByName);

                            $scope.otherResources = $scope.resources.filter(resource => !isCorrelated(resource))
                                .sort(sortByName);
                        }

                        function checkIfSelectedProductNeedsResources() {
                            splitResourcesByProduct();
                            if (!$scope.form.selectedProduct) {
                                $scope.selectedProductNeedsResources = false;
                                return;
                            }

                            $scope.selectedProductNeedsResources = !!$scope.form.selectedProduct.needsResources;

                            if ($scope.selectedProductNeedsResources && !$scope.showingResources) {
                                $scope.showingResources = true;
                                checkResources();
                            }
                        }
                    }
                }
            }
        });
});